[data-html-img] {
  max-width:100%;
  max-height:100%;
}